<template>
  <div class="admin-page">
    <el-tabs v-model="activeTab" @tab-change="onTabChange">
      <el-tab-pane label="登录 / IP 变更" name="access">
        <div class="admin-toolbar">
          <div class="admin-toolbar__actions">
            <el-input v-model="accessFilters.userUuid" placeholder="用户 UUID" clearable class="filter-input-wide" @keyup.enter="fetchAccess" />
            <el-input v-model="accessFilters.username" placeholder="用户名" clearable class="filter-input" @keyup.enter="fetchAccess" />
            <el-input v-model="accessFilters.ip" placeholder="IP" clearable class="filter-input" @keyup.enter="fetchAccess" />
            <el-select v-model="accessFilters.eventType" placeholder="事件" clearable class="filter-select" @change="fetchAccess">
              <el-option label="全部" value="" />
              <el-option label="登录" value="login" />
              <el-option label="IP 变更" value="ip_change" />
            </el-select>
            <el-button type="primary" @click="fetchAccess">查询</el-button>
          </div>
        </div>
        <el-table :data="accessLogs" v-loading="accessLoading" style="width: 100%">
          <el-table-column prop="id" label="ID" width="70" />
          <el-table-column label="用户" min-width="140">
            <template #default="scope">
              <div>{{ scope.row.nickname || scope.row.username || '—' }}</div>
              <div class="muted uuid-line">{{ scope.row.userUuid }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="ip" label="IP" width="140" />
          <el-table-column prop="ipLocation" label="归属地" min-width="160" show-overflow-tooltip>
            <template #default="scope">{{ scope.row.ipLocation || '—' }}</template>
          </el-table-column>
          <el-table-column prop="eventType" label="类型" width="100">
            <template #default="scope">
              <el-tag :type="scope.row.eventType === 'login' ? 'success' : 'warning'">
                {{ scope.row.eventType === 'login' ? '登录' : 'IP变更' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="requestPath" label="路径" min-width="160" show-overflow-tooltip />
          <el-table-column label="时间" width="170">
            <template #default="scope">{{ formatTime(scope.row.createdAt) }}</template>
          </el-table-column>
        </el-table>
        <AdminPagination
          v-model:current-page="accessPage"
          v-model:page-size="accessPageSize"
          :total="accessTotal"
          @size-change="fetchAccess"
          @current-change="fetchAccess"
        />
      </el-tab-pane>

      <el-tab-pane label="危险 IP" name="danger">
        <div class="admin-toolbar">
          <div class="admin-toolbar__actions">
            <el-input v-model="dangerFilters.ip" placeholder="IP" clearable class="filter-input" @keyup.enter="fetchDanger" />
            <el-select v-model="dangerFilters.status" class="filter-select" @change="fetchDanger">
              <el-option label="全部" :value="-1" />
              <el-option label="危险中" :value="1" />
              <el-option label="已解除" :value="0" />
            </el-select>
            <el-button type="primary" @click="fetchDanger">查询</el-button>
          </div>
        </div>
        <el-table :data="dangerLogs" v-loading="dangerLoading" style="width: 100%">
          <el-table-column prop="id" label="ID" width="70" />
          <el-table-column prop="ip" label="IP" width="140" />
          <el-table-column prop="ipLocation" label="归属地" min-width="160" show-overflow-tooltip>
            <template #default="scope">{{ scope.row.ipLocation || '—' }}</template>
          </el-table-column>
          <el-table-column prop="qpsPeak" label="峰值QPS" width="100" />
          <el-table-column prop="status" label="状态" width="90">
            <template #default="scope">
              <el-tag :type="scope.row.status === 1 ? 'danger' : 'info'">
                {{ scope.row.status === 1 ? '危险' : '已解除' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="关联用户" min-width="160">
            <template #default="scope">
              <div v-if="scope.row.userUuid">{{ scope.row.nickname || scope.row.username || '—' }}</div>
              <div v-if="scope.row.userUuid" class="muted uuid-line">{{ scope.row.userUuid }}</div>
              <span v-else class="muted">—</span>
            </template>
          </el-table-column>
          <el-table-column label="触发时间" width="170">
            <template #default="scope">{{ formatTime(scope.row.triggeredAt) }}</template>
          </el-table-column>
          <el-table-column label="解除时间" width="170">
            <template #default="scope">{{ scope.row.clearedAt ? formatTime(scope.row.clearedAt) : '—' }}</template>
          </el-table-column>
        </el-table>
        <AdminPagination
          v-model:current-page="dangerPage"
          v-model:page-size="dangerPageSize"
          :total="dangerTotal"
          @size-change="fetchDanger"
          @current-change="fetchDanger"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import axios from 'axios'
import AdminPagination from '@/components/AdminPagination.vue'
import { authHeaders } from '@/utils/http'

export default {
  name: 'UserIpLogManagement',
  components: { AdminPagination },
  data() {
    return {
      activeTab: 'access',
      accessLoading: false,
      accessLogs: [],
      accessTotal: 0,
      accessPage: 1,
      accessPageSize: 20,
      accessFilters: { userUuid: '', username: '', ip: '', eventType: '' },
      dangerLoading: false,
      dangerLogs: [],
      dangerTotal: 0,
      dangerPage: 1,
      dangerPageSize: 20,
      dangerFilters: { ip: '', status: -1 }
    }
  },
  created() {
    this.fetchAccess()
  },
  methods: {
    formatTime(ts) {
      if (!ts) return '—'
      return new Date(ts * 1000).toLocaleString()
    },
    onTabChange(name) {
      if (name === 'danger') this.fetchDanger()
      else this.fetchAccess()
    },
    async fetchAccess() {
      this.accessLoading = true
      try {
        const res = await axios.post(
          '/api/v1/admin/user/ip-log/list',
          {
            page: this.accessPage,
            pageSize: this.accessPageSize,
            userUuid: this.accessFilters.userUuid || undefined,
            username: this.accessFilters.username || undefined,
            ip: this.accessFilters.ip || undefined,
            eventType: this.accessFilters.eventType || undefined
          },
          { headers: authHeaders() }
        )
        if (res.data.code !== 200) {
          this.$message.error(res.data.message || '加载失败')
          return
        }
        this.accessLogs = res.data.data?.logs || []
        this.accessTotal = res.data.data?.total || 0
      } catch (e) {
        this.$message.error(e.response?.data?.message || '加载失败')
      } finally {
        this.accessLoading = false
      }
    },
    async fetchDanger() {
      this.dangerLoading = true
      try {
        const res = await axios.post(
          '/api/v1/admin/danger-ip/list',
          {
            page: this.dangerPage,
            pageSize: this.dangerPageSize,
            ip: this.dangerFilters.ip || undefined,
            status: this.dangerFilters.status
          },
          { headers: authHeaders() }
        )
        if (res.data.code !== 200) {
          this.$message.error(res.data.message || '加载失败')
          return
        }
        this.dangerLogs = res.data.data?.logs || []
        this.dangerTotal = res.data.data?.total || 0
      } catch (e) {
        this.$message.error(e.response?.data?.message || '加载失败')
      } finally {
        this.dangerLoading = false
      }
    }
  }
}
</script>

<style scoped>
.muted {
  color: #909399;
  font-size: 12px;
}
.uuid-line {
  word-break: break-all;
}
</style>
